<mat-card class="filter settingHeader">
  <div class="name">
    Manage Task List Templates

    <button mat-icon-button color="primary" *ngIf="showOptionForDelete" (click)="deleteMultipleTaskTemplates()">
      <mat-icon>delete</mat-icon>
    </button>

  </div>


  <div class="quickAction">

    <mat-form-field appearance="fill">
      <mat-label>Select Category</mat-label>
      <mat-select (selectionChange)="OnChnageCategory($event)" value="My Template">
        <mat-option value="My Template">My Template</mat-option>
        <mat-option value="Organization">Organization Template</mat-option>           
      </mat-select>
    </mat-form-field>

    <!-- <mat-form-field appearance="">
      <mat-label>Search items in task status</mat-label>
      <input matInput type="text" [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
      <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>close</mat-icon>
      </button>
      <button  *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field> -->



  </div>
</mat-card>


<div class="documents">

  <mat-card class="example-list rowholder" *ngIf="!ShowNoRecordFound">
    <div class="fieldRow head">
      <span class="checkBox"></span>
      <span class="templateName">Template</span>
      <span class="category">Level</span>
      <span class="category">Category</span>

      <span class="sendTaskList">Send Task List</span>
      <span class="actions">Actions</span>

    </div>

    <ng-container *ngFor="let temp of taskTemplateList">
      <div class="fieldRow">


        <span class="checkBox"> <mat-checkbox color="primary" (change)="selectRecordForDelete($event,temp)">
          </mat-checkbox>
        </span>


        <span class="templateName">
          <a (click)="OpenFolderSendEmail(SendTaskListURL,temp)">{{temp.taskTemplateName}}</a>          
        </span>

        <span class="category">
          <ng-container *ngIf="temp.type==0">
            <span>My Template</span>
          </ng-container>   
          <ng-container *ngIf="temp.type==1">
            <span>Global</span>
          </ng-container>   
          <ng-container *ngIf="temp.type==2">
            <span>Organization</span>
          </ng-container>       
        </span>

        <span class="category">
          <ng-container *ngIf="temp.folderName==null">
            <span>-</span>
          </ng-container>
          <ng-container *ngIf="temp.folderName!=null">
            <span>{{temp.folderName}}</span>
          </ng-container>
        </span>


        <span class="sendTaskList">
          <button   mat-icon-button matTooltipClass="tooltip" matTooltip="Dashboard Quick Link" (click)="selectIcon(temp)">
            <mat-icon>add</mat-icon>
          </button>
          <button mat-icon-button matTooltipClass="tooltip" matTooltip="Send task list" color="primary"
            (click)="OpenFolderSendEmail(SendTaskListURL,temp)"><mat-icon> email</mat-icon></button>

            <button class="tempDetail" mat-icon-button matTooltipClass="tooltip" matTooltip="View Detail" color="basic"
            (click)="showTemplateDetail(temp.taskTemplateID)"><mat-icon>description</mat-icon></button>
        </span>


        <span class="actions">



          <button mat-icon-button matTooltipClass="tooltip" matTooltip="Add header banner" color="basic"
            [disabled]="!temp.isActive" (click)="editBanner(banner,temp)"><mat-icon>image</mat-icon></button>
          <button mat-icon-button matTooltipClass="tooltip" matTooltip="Copy link" color="basic"
            [disabled]="!temp.isActive" [cdkCopyToClipboard]="temp.token"
            (click)="linkCopied()"><mat-icon>link</mat-icon></button>
          <button mat-icon-button matTooltipClass="tooltip" matTooltip="Select folder" color="basic"
            [disabled]="!temp.isActive" (click)="OpenFolder(folder,temp)"><mat-icon>folder</mat-icon></button>
          <button mat-icon-button matTooltipClass="tooltip" matTooltip="Edit Name" class="basic"
            [disabled]="!temp.isActive" (click)="UpdateTaskDialog(myUpdateDialog,temp)">
            <mat-icon>edit</mat-icon>
          </button>

          <mat-slide-toggle color="primary" [checked]="temp.isActive" (change)="UpdateTemplateToggle(temp,$event)">
          </mat-slide-toggle>

        </span>




      </div>
    </ng-container>

    <!-- <mat-paginator [pageIndex]="pageIndex" [pageSize]="pageSize" [length]="paginatorTotalLength" [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons  (page)="CallNextPrevPageData($event)"></mat-paginator> -->

    <div class="showTaskTempalteDetail" *ngIf="showTaskTempalteDetail">

      <div class="header">
        <h2>Template Detail</h2>

        <button mat-icon-button color="basic" (click)="closeTemplateDetail()">
          <mat-icon>close</mat-icon>
        </button>

      </div>

      <div class="emailList1">

        <div class="email" *ngFor="let item of sendForSign">

          <span>
            <span *ngIf="item.isSent == true" class="sentEmail" else notSent><mat-icon>task_alt</mat-icon></span>
            <span *ngIf="item.cType == 1" class="sentEmail" else notSent><mat-icon>app_registration</mat-icon></span>

            <ng-template #notSent *ngIf="item.messageType == 1">
              <mat-icon class="noSentEmail">task_alt</mat-icon>
            </ng-template>
            <p *ngIf="item.cName!=null"> <span>{{item.cName}} </span> <span>{{item.email}} </span> </p>
            <p *ngIf="item.cName==null"> <span>{{item.email}} </span> </p>
            <ng-template #notSent *ngIf="item.messageType == 2">
              <mat-icon class="noSentEmail">task_alt</mat-icon>
            </ng-template> {{ item.phoneno}}

          </span>

          <span>
            <!-- *ngIf="item.messageType != 0" -->
            <button *ngIf="item.messageType != 0" matTooltipClass="tooltip" matTooltip="Resend" mat-icon-button
              (click)="resendTaskTemplate(item.taskTemplateSentToID)">
              <mat-icon>outgoing_mail</mat-icon>
            </button>

            <i *ngIf="item.lastSentDate != '0001-01-01T00:00:00'" >{{item.lastSentDate+'Z' | date: 'MM/dd/yyyy, h:mm:ss' }}</i>
            <i *ngIf="item.lastSentDate == '0001-01-01T00:00:00'" >{{item.createdOn+'Z' | date: 'MM/dd/yyyy, h:mm:ss' }}</i>

            <button mat-icon-button color="primary" (click)="deleteTaskTemplates(item)">
              <mat-icon>delete</mat-icon>
            </button>
          </span>

        </div>

      </div>

    </div>

  </mat-card>
  <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>

</div>



<ng-template #myUpdateDialog>
  <form [formGroup]="updateformDialog">
    <h2 mat-dialog-title>
      Update Task Template
      <button mat-icon-button (click)="closeUpdate()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content class="mat-typography">
      <mat-form-field class="example-full-width">
        <mat-label>Template Name</mat-label>
        <input matInput [required]="true" maxlength="50" placeholder="update template name"
          formControlName="taskTemplateName" />
        <mat-error *ngIf="updateformDialog.get('taskTemplateName').invalid &&
        (updateformDialog.get('taskTemplateName').dirty ||
        updateformDialog.get('taskTemplateName').touched)">
          <span>This field is mandatory.</span>
        </mat-error>
      </mat-form-field>

    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <button mat-button (click)="closeUpdate()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="updateformDialog.invalid || !updateformDialog.dirty"
        (click)="UpdateTaskTemplate(updateformDialog.value)">
        Update
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>
    <app-loader></app-loader>
  </form>
</ng-template>



<ng-template #banner>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>note_add</mat-icon></span>
    Add Banner
    <button mat-icon-button (click)="closeFolder()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>

    <div class="iframe-drag-bounds-header">

      <div class="customUpdate">
        <div class="bannerText">
          <input matInput type="text" maxlength="100" placeholder="Enter banner heading" [(ngModel)]="headerText"
            (input)="onSearchChange($event.target.value)" />

          <!-- <input type="text" placeholder="Enter banner heading" > -->
        </div>
        <div class="bgbanner">
          <div class="bannerUpload">
            <mat-icon>cloud_upload</mat-icon>
            Upload Banner (.jpg, .png)
          </div>

          <div class="uploadedData">
            <img *ngIf="ImageUploadURL!=''" src="{{ ImageUploadURL }}" alt="" />
            <!-- <img  [src]="img.Imageurl"/>  img -->
          </div>

          <input type="file" alt="" class="form-control" accept="image/*" (change)="onSelectFile($event)" />

          <div class="bannerUpload">
            <i>1200x100</i>
            Suggested Size
          </div>

        </div>
      </div>

    </div>


  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeFolder()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary" [disabled]="!ButtonForUploadImage"
      (click)="AddUpdateHeadertoTaskTemplate()">
      Add
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
    </button>
  </mat-dialog-actions>

</ng-template>


<ng-template #folder>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>note_add</mat-icon></span>
    Task List
    <button mat-icon-button (click)="closeFolder()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>

    <h2><mat-icon class="type">checklist</mat-icon> Task lists</h2>
    <div class="drive mainLink">
      <div class="folderName" *ngFor="let tasklist of taskListFolder">

        <div class="folderRow" [ngClass]="{ 'active': taskListFolderID === tasklist.taskListFolderID }"
          (click)="selectTaskListFolder(tasklist)">
          <mat-icon class="type">folder</mat-icon>
          <p>
            {{tasklist.taskListFolderName}}
          </p>

        </div>

      </div>
    </div>
    <br>
    <h2><mat-icon class="type">share</mat-icon> Shared with me </h2>
    <div class="drive mainLink">
      <div class="folderName" *ngFor="let tasklist1 of taskListFolderSharedWithMe ;let i= index">

        <div class="folderRow" [ngClass]="{ 'active': taskListFolderIDSharedWithMe === tasklist1.id }"
          (click)="selectTaskListFolderSharedWithMe(tasklist1)">
          <mat-icon class="type">folder</mat-icon>
          <p>
            {{tasklist1.name}}
          </p>

        </div>

      </div>
    </div>



  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeFolder()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary" [disabled]="!ButtonForFolder"
      (click)="AddUpdateTaskListFoldertoTaskTemplate()">
      Add
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
    </button>
  </mat-dialog-actions>

</ng-template>

<ng-template #SendTaskListURL>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>mail</mat-icon></span>
    Create and send tasklist
    <button mat-icon-button (click)="closeSendTaskListURL()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>

    <ng-container *ngIf="showAuthenticationType">
      <div class="title">Send to {{CoreShowName}}</div>

      <div class="authopt">        
      </div>
    </ng-container>
  
    <div class="emailListHolder" *ngIf="selectCoreList.length > 0">
      <ng-container *ngFor="let email of selectCoreList">
      <div class="emailList" >

        <div class="left">

          <div class="info first">
            <span> Name</span>
            <p>{{email.name}}</p>            
          </div>
        
          <div class="info">
            <span> Email</span>
            <p>{{email.emailid}}</p>            
          </div>

        </div>
        <div class="right">
          <div class="info assignto">
            <input type="checkbox"  (change)="onNotASignerChange($event, email)" [checked]="email.isNotASigner">  <span> Assign to someone else          </span>
            
          </div>
          <div class="act">
            <button color="primary" class="close" mat-icon-button
            (click)="editCore(email)">
            <mat-icon>edit</mat-icon>
           </button>
  
            <button color="primary" class="close" mat-icon-button
              (click)="removeCore(email.emailid)">
              <mat-icon>close</mat-icon>
            </button>
         
          </div>
        </div>




      </div>

      <div class="emailList" [id]="'1_Search' + email.emailid"  *ngIf="email.isNotASigner==true && email.contactAttachWithCores.length==0" >
        <div class="block mt-10" >
          <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
            <mat-label>Search {{ContactShowName}}</mat-label>
            <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="autoContact"
              (input)="searchContacts($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
            <mat-autocomplete #autoContact="matAutocomplete">
              <mat-option (click)="contactSelectedNew(contact,email.emailid)"
                *ngFor="let contact of attachedToContactList" [value]="contact.name">
                <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                  <div class="userpic">
                    <img *ngIf="contact.imageUrl!=''" src="{{contact.imageUrl}}" alt="">
                    <span class="username" *ngIf="contact.imageUrl==''" class="username">
                      {{contact.shortName}}
                    </span>
                  </div>
                  <div class="info">
                    <p> {{ contact.name }}</p>
                    <p class="email">{{ contact.email }}</p>
                  </div>
                </span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
         
        </div>
      </div>
      <div class="emailList"  [id]="'1_List' + email.emailid" *ngIf="email.isNotASigner==true && email.contactAttachWithCores.length>0" >
        <!-- <div class="info first">
          <span> {{ContactShowName}}</span>
        </div> -->
        <div class="left">
          <div class="info first">
            <span> Name</span>
            <p>{{email.contactAttachWithCores[0].name}}</p>            
          </div>
              
          <div class="info">
            <span> Email</span>
            <p>{{email.contactAttachWithCores[0].email}}</p>            
          </div>
        </div>
            
       <div class="right">

        <div class="info">
          <mat-select (selectionChange)="OnChnageRelation($event,email)" value="0" style="width: 150px;" >
            <mat-option value="0">Select Relation</mat-option>
            <mat-option  *ngFor="let relation of relationList" [value]="relation.relationID">{{relation.relationName}}</mat-option> 
          </mat-select>
        </div>
            <button color="primary" class="close" mat-icon-button
              (click)="removeContactWithCoreCore(email)">
              <mat-icon>close</mat-icon>
            </button>

       </div>
       
      </div>
      
    </ng-container>
    </div>



    <!-- <div class="mb-10">

      <mat-checkbox *ngIf="selectCoreList.length > 0" color="primary" [(ngModel)]="SendEmailLater" (change)="showOptions($event,'SendEmailLater')">Send Email Notification Later
      </mat-checkbox> &nbsp;
      </div> -->


      <div class="sepreator"></div>
  
  <div class="drive mainLink">
    <ng-container>
      <mat-form-field  appearance="fill">
        <input matInput placeholder="Search or Select {{CoreShowName}}" [formControl]="stateCtrl"
          (input)="searchCore($event.target.value)" [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option  (click)="coreSelected(core)" 
             *ngFor="let core of attachedToCoreList" [value]="core.name">
              <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                  <div class="userpic">
                      <img *ngIf="core.imageUrl!=''" src="{{core.imageUrl}}" alt="">
                      <span class="username" *ngIf="core.imageUrl==''" class="username">
                          {{core.shortName}}
                        </span>
                  </div>
                  <div class="info">
                    <p> {{ core.name }}</p>
                    <p class="email">{{ core.email }}</p>
                  </div> 
              </span> 
            </mat-option>
          </mat-autocomplete>
      </mat-form-field>
    </ng-container>
  </div>
  



  </mat-dialog-content>

  <div class="sepreator"></div>
  
  <mat-checkbox color="primary" [(ngModel)]="AssigneeChecked" (change)="showOptions($event,'Assignee')">Assign the same Users as template
  </mat-checkbox>&nbsp;
  
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeSendTaskListURL()">Cancel</button>

    <button mat-flat-button style="margin-left: 215px;" class="calltoaction" type="submit" color="primary"
    [disabled]="selectCoreList.length==0" 
    (click)="SendEmailForTaskListURL(false)">
     Create & Send
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
  </button>

    <button mat-flat-button class="calltoaction" type="submit" color="primary"
      [disabled]="selectCoreList.length==0" 
      (click)="SendEmailForTaskListURL(true)">
      Create Only
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
    </button>
  </mat-dialog-actions>

</ng-template>


<app-addnew *ngIf="showAddCore" (closeAdd)="getClose($event)" [name]="searchName" [isShared]="isShare"
  [mainModuleName]='mainModuleName' [modulename]='Module' [SendingFor]="sendFrom" [ngClass]="{'open': showAddCore}" 
  (selectedCoreIdForSendTaskList)=getselectedTransactionId($event)>
</app-addnew>

<app-details *ngIf="showDetail"  [ngClass]="{ open: showDetail }" [transactionID]='transactionID'
[modulenames]='mainModuleNameForDetails' [SendingFor]="sendFrom"
(selectedCoreIdForSendTaskListUpdate)=getUpdatedRecord($event) (closeDetail)="getCloseDetails($event)">
</app-details>

<app-loader></app-loader>